<!--
 * @Author: 王云飞
 * @Date: 2022-01-20 09:20:27
 * @LastEditTime: 2022-01-20 09:52:03
 * @LastEditors: 王云飞
 * @Description: 
 * 
-->
<template>
  <div class="sdk-doc">
    <h3 class="mg-bt">APP第三方及关联方SDK目录</h3>
    <p>1:为保障大众签章相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方及关联方提供的软件开发包（SDK）实现相关目的。</p>
    <p>2:我们会对获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。</p>
    <p>3:我们对接入的相关SDK在目录中列明。</p>
    <p class="mg-bt">4:请注意，第三方及关联方SDK可能因为其版本升级、策略调整等原因导致数据处理类型存在一定变化，请以其公示的官方说明为准。</p>
    <h3 class="mg-bt">大众签章接入SDK目录</h3>
    <h4 class="mg-bt-5">Android接入第三方SDK目录</h4>
    <strong>1:高德地图</strong>
    <p>使用目的：帮助用户发布信息时定位位置；小程序使用时提供位置信息</p>
    <p>收集数据类型：设备识别信息、地理位置信息</p>
    <p class="mg-bt">官网地址：<a href="https://lbs.amap.com/">https://lbs.amap.com/</a></p>
    <strong>2:腾讯开放平台</strong>
    <p>使用目的：数据分享</p>
    <p class="mg-bt">官网地址：<a href="https://open.tencent.com/">https://open.tencent.com/</a></p>
    <h4 class="mg-bt-5">IOS接入第三方SDK目录</h4>
    <strong>1:高德地图</strong>
    <p>使用目的：<span>帮助用户发布信息时定位位置；小程序使用时提供位置信息</span></p>
    <p>收集数据类型：<span>设备识别信息、地理位置信息</span></p>
    <p class="mg-bt">官网地址：<a href="https://lbs.amap.com/">https://lbs.amap.com/</a></p>
    <strong>1:推送通知</strong>
    <p>使用目的：<span>推送消息</span></p>
    <p>收集数据类型：<span>设备识别信息</span></p>
    <p class="mg-bt">官网地址：<a href="https://www.aliyun.com/">https://www.aliyun.com/</a></p>

    <h4 class="mg-bt-5">Android接入关联方SDK目录</h4>
    <strong>1:dzonesignLib</strong>
    <p>使用目的：<span>渲染pdf文件</span></p>
    <p>收集数据类型：<span></span></p>
    <p>公司主体：<span>山东国盾网信息科技有限公司</span></p>

    <h4 class="mg-bt-5">IOS接入关联方SDK目录</h4>
    <strong>1:libPdfEngine.a</strong>
    <p>使用目的：<span>渲染pdf文件</span></p>
    <p>收集数据类型：<span></span></p>
    <p class="mg-bt">公司主体：<span>山东国盾网信息科技有限公司</span></p>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
$margin-bt: 10px;
$margin-bt5: 5px;
.sdk-doc {
  height: 100%;
  overflow: auto;
  .mg-bt {
    margin-bottom: $margin-bt;
  }
  .mg-bt-5 {
    margin-bottom: $margin-bt5;
  }
  text-align: left;
  strong {
    font-weight: bold;
  }
  a {
    word-wrap: break-word;
  }
  h3,
  h4 {
    font-weight: bold;
  }
  a {
    color: blue;
    text-decoration: underline;
  }
}
</style>